import ReactMarkdown from "react-markdown";
import { HiExternalLink } from "react-icons/hi";
import { LuArrowRight, LuCornerDownLeft } from "react-icons/lu";
import { PiCheckBold } from "react-icons/pi";

const sectionOf = (focusField) => {
  if (focusField.startsWith("patient.mutuelle")) return "Mutuelle";
  if (focusField.startsWith("patient")) return "Patient";
  if (focusField.startsWith("prescriptions")) return "Ordonnance";
  if (focusField.startsWith("sampl")) return "Prélèvement";
  return "Structure";
};

const SubmitConfirmModal = ({ missingFields, guidelines, action, loading = false, onGuidelineValidatedChange, onFocusField, onClose, onConfirm }) => {
  const actionLabel = action === "PRODUCTION" ? "Envoyer en production" : "Valider";
  const pendingCount = missingFields.length + guidelines.filter((g) => g.validated !== true).length;
  return (
    <div className="fixed inset-0 z-[220] flex items-center justify-center bg-black/20">
      <div className="mx-4 w-full max-w-[460px] overflow-hidden rounded-xl bg-white shadow-xl ring-1 ring-black/5">
        <h2 className="px-5 pb-3 pt-4 text-[15px] font-semibold text-gray-900">{action === "PRODUCTION" ? "Avant d'envoyer en production" : "Avant de valider"}</h2>

        <div className="max-h-80 divide-y divide-gray-100 overflow-auto border-y border-gray-100">
          {missingFields.map((field) => (
            <button
              key={field.label}
              type="button"
              className="group flex w-full items-center gap-3 px-5 py-2.5 text-left transition-colors hover:bg-gray-50"
              onClick={() => {
                onClose();
                onFocusField(field.focusField);
              }}
            >
              <span className="size-1.5 shrink-0 rounded-full bg-orange-400" />
              <span className="text-[13px] font-medium text-gray-900">{field.label}</span>
              {field.focusField !== "prescriptions" && <span className="text-[13px] text-gray-400">{sectionOf(field.focusField)}</span>}
              <LuArrowRight className="ml-auto size-3.5 shrink-0 text-gray-300 transition-colors group-hover:text-gray-600" />
            </button>
          ))}
          {guidelines.map((guideline) => {
            const isValidated = guideline.validated === true;
            return (
              <div key={guideline._id} className="flex items-start gap-3 px-5 py-2.5">
                <button
                  type="button"
                  role="checkbox"
                  aria-checked={isValidated}
                  title={isValidated ? "Marquer comme non validée" : "Marquer comme validée"}
                  onClick={() => onGuidelineValidatedChange(guideline._id, !isValidated)}
                  className={`mt-px flex size-[16px] shrink-0 items-center justify-center rounded border transition-colors ${
                    isValidated ? "border-primary-500 bg-primary-500 text-white" : "border-orange-300 bg-white text-transparent hover:border-orange-500"
                  }`}
                >
                  <PiCheckBold className="size-2.5" />
                </button>
                <div className={`min-w-0 flex-1 text-[13px] leading-snug ${isValidated ? "text-gray-400 line-through" : "text-gray-800"}`}>
                  <ReactMarkdown
                    components={{
                      a: (props) => (
                        <a {...props} target="_blank" rel="noopener noreferrer" className="flex items-center text-primary-600 underline hover:text-primary-800">
                          <HiExternalLink className="h-4 w-4" />
                          {props.children}
                        </a>
                      ),
                      p: (props) => (
                        <p {...props} className="whitespace-pre-line">
                          {props.children}
                        </p>
                      ),
                      ul: (props) => <ul {...props} className="list-inside list-disc space-y-1" />,
                      li: (props) => <li {...props} className="whitespace-pre-line" />,
                    }}
                  >
                    {guideline.secretaryGuideline}
                  </ReactMarkdown>
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex items-center gap-2 px-5 py-3">
          {pendingCount > 0 && (
            <span className="whitespace-nowrap text-xs text-gray-400">
              {pendingCount} point{pendingCount > 1 ? "s" : ""} en attente
            </span>
          )}
          <button
            type="button"
            className="ml-auto rounded-lg px-3 py-1.5 text-[13px] font-medium text-gray-600 transition-colors hover:bg-gray-100 disabled:opacity-50"
            onClick={onClose}
            disabled={loading === true}
          >
            Annuler
          </button>
          <button
            type="button"
            autoFocus
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-lg bg-primary-500 px-3 py-1.5 text-[13px] font-medium text-white transition-colors hover:bg-primary-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-200 disabled:opacity-50"
            onClick={onConfirm}
            disabled={loading === true}
          >
            {loading === true ? "Chargement..." : pendingCount === 0 ? actionLabel : action === "PRODUCTION" ? "Envoyer quand même" : "Valider quand même"}
            <LuCornerDownLeft className="size-3 opacity-70" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubmitConfirmModal;
